export default __webpack_public_path__ + "static/media/promo_icon.474d01ef.svg";